export default from './post-page-stats';



// WEBPACK FOOTER //
// ./app/components/post-page-stats/index.js